// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__zJDIV","filters_close":"FiltersBlock_filters_close__O9BN-"};